import { ButtonPermissionMap } from '@/projects/operation/constant/ButtonPermission'
export default [
  {
    name: 'coupon_budget',
    path: '/coupon_budget',
    component: () =>
      import(/* webpackChunkName: "coupon_budget" */ './index.vue')
  },
  {
    name: 'DepositInternalAccount',
    path: '/internal_account/deposit',
    meta: {
      permission: ButtonPermissionMap.DepositInternalAccount
    },
    component: () =>
      import(
        /* webpackChunkName: "internal_account" */ '@/projects/teller/views/InternalAccount/DepositInternalAccount.vue'
      )
  },
  {
    name: 'WithdrawalInternalAccount',
    path: '/internal_account/withdrawal',
    meta: {
      permission: ButtonPermissionMap.WithdrawalInternalAccount
    },
    component: () =>
      import(
        /* webpackChunkName: "internal_account" */ '@/projects/teller/views/InternalAccount/WithdrawalInternalAccount.vue'
      )
  }
]
